import { post } from '../../utils/http';

export const autoScheduleProject = ({ accountId, branchId, projectId, shiftIds, scheduleAllShifts }) =>
  post(`/accounts/${accountId}/branches/${branchId}/schedule/auto`, { projectId, shiftIds, scheduleAllShifts });

export const revertAutoScheduleProject = ({ accountId, branchId, projectId, assignments }) =>
  post(`/accounts/${accountId}/branches/${branchId}/schedule/auto/revert`, { projectId, assignments });

export const revertAllAutobookedEmployees = ({ accountId, branchId, projectId }) =>
  post(`/accounts/${accountId}/branches/${branchId}/schedule/auto/revert-all`, { projectId });
